export default function LatchkeyNamesParser(product?: Product): string[] {
  return product?.detail?.orderedMasterGroupList || [];
}
